export function checkRulesDigit(value: string, max = 13) {
  const length = value.length
  if (length !== max && value) {
    return false
  }
  return true
}
export function checkRfcFormat(value: string) {
  if (value) {
    const reg = /^[a-zA-Z]{4}[0-9]{6}/
    return reg.test(value)
  }
  return true
}

/**
 * 校验手机号为10-14位纯数字
 * @refs https://git.xiaojukeji.com/manhanttan-global/manhattan-freya-webapp/blob/master/components/common/personal-info/useValidate.ts#L185
 */
export function validatePhoneNumber(phoneNumber: string) {
  const pattern = /^\d{10,14}$/
  return pattern.test(phoneNumber)
}

/**
 * 校验手机号不包含10位连续数字：0123456789、1234567890、且不为相同的10位数字；
 * @refs https://git.xiaojukeji.com/manhanttan-global/manhattan-freya-webapp/blob/master/components/common/personal-info/useValidate.ts#L197
 */
export const isFitRequirementCode = (
  code: string | number | Array<string | number>,
  flatNumber?: number
): boolean => {
  let codeList = []
  let flag = 0
  if (code instanceof Array) {
    codeList = [...code]
  } else if (Boolean(code) === false) {
    return false
  } else {
    codeList = Array.from(code.toString())
  }

  /**
   * 判断电话号中是否存在连续相同的十位数字
   */
  const patternNumber = /(\d)\1{9}/
  if (patternNumber.test(code.toString())) {
    return false
  }
  const pattern =
    /1234567890|0123456789|9876543210|0987654321/
  // const pattern = /^1234567890$/
  if (pattern.test(code.toString())) {
    return false
  }
  // 判断是否有相同数字
  const handleCodeList = [...new Set(codeList)]
  if (handleCodeList.length === 1) {
    return false
  }
  // 判断是否为等差数列
  flag = flatNumber
    ? flatNumber
    : Number(codeList[1]) - Number(codeList[0]) > 0
    ? 1
    : -1
  const res = canMakeArithmeticProgression(
    codeList as number[],
    flag
  )
  return res
}

// 判断是否为等差数列
function canMakeArithmeticProgression(
  arr: number[],
  flat: number
): boolean {
  const c: number = flat
  for (let i = 1; i < arr.length; i++) {
    const cha = arr[i] - arr[i - 1]
    if (cha != c) {
      return true
    }
  }
  return false
}

/**
 *
 * @description 校验邮箱@ 符号前长度
 * @param email
 * @returns
 */
export function checkEmailLength(email: string): boolean {
  // 通过正则表达式验证邮箱格式
  try {
    const parts = email.split('@') // 按@符号分割邮箱地址
    if (parts.length < 2) {
      return false
    }
    const leftPart = parts[0] // 左侧部分
    if (leftPart.length >= 5) {
      return true // 左侧部分长度大于等于5，校验通过
    }
    return false // 校验不通过
  } catch (error) {
    return false
  }
}

/**
 * @description 校验email 后缀是否包含 co|cm|om 如包含给用户提示
 * @param email
 * @returns
 */
export function checkEmailPrefix(email: string): boolean {
  const reg = /^[\d\D]+\.([\d\D]+)$/
  const arr = reg.exec(email)
  if (arr) {
    const domain = arr[1].toLowerCase()
    if (['co', 'cm', 'om'].includes(domain)) {
      return false
    }
    return true
  }
  return false
}

/**
 * @description 校验email 后缀是以co|cm|om|com|net|mx|es 以外的后缀结尾
 * @param email
 * @returns
 */
export function checkEmailContainPrefix(
  email: string
): boolean {
  const reg = /^[\d\D]+\.([\d\D]+)$/
  const arr = reg.exec(email)
  if (arr) {
    const domain = arr[1].toLowerCase()
    if (
      ['co', 'cm', 'om', 'com', 'net', 'mx', 'es'].includes(
        domain
      )
    ) {
      return true
    }
    return false
  }
  return false
}

/**
 * @description  校验email 后缀是否包含 'com', 'es', 'mx', 'net'
 * @param value
 * @returns
 */
export function checkEmailDomainsNew(
  value: string
): boolean {
  const reg = /^[\d\D]+\.([\d\D]+)$/
  const arr = reg.exec(value)

  if (arr) {
    const domain = arr[1].toLowerCase()
    return !!['com', 'es', 'mx', 'net'].find((element) => {
      return domain === element.toLowerCase()
    })
  }
  return true
}

/**
 * 校验邮箱
 * @param value
 * @returns
 */
export const checkEmail = (value: string) => {
  const reg =
    /^[^<>()[\]\\.,;\-:\s@"]+(\.[^<>()[\]\\.,;\-:\s@"]+)*@([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}$/
  if (!reg.test(value)) {
    return false
  } else {
    return true
  }
}

/**
 * 校验是否仅包含非数字字符
 * @param value
 * @returns
 */
export const checkNonNumeric = (value: string) => {
  const reg = /^[^0-9]+$/g
  return reg.test(value)
}

/**
 * 校验curp
 * @param value
 * @returns
 */

export const curpValidate = (value: string) => {
  // curp 正则
  const curpReg =
    /^[a-zA-Z]{4}[0-9]{2}((0[1-9])|(1[0-2]))((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1]))[a-zA-Z]{6}([a-zA-Z]|[0-9])[0-9]$/g
  // 重置lastIndex
  curpReg.lastIndex = 0
  return curpReg.test(value)
}
